import "./NavBack.css";
import React from "react";
import { useNavigate, Link } from "react-router-dom";

type Props = {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  title?: string;
  className?: string;
  fixed?: boolean;
  children?: React.ReactNode;
};
export default function NavBack({
  onClick,
  title,
  className = "",
  fixed = false,
  children,
}: Props) {
  const navigate = useNavigate();
  const backClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) return onClick(e);
    navigate(-1);
  };
  return (
    <>
      <nav
        id="navBarApp"
        className={
          `navbar navbar-light bg-white shadow-sm ${fixed ? "fixed-top" : ""} ` +
          className
        }
      >
        <div className="container-fluid">
          <Link to="/" onClick={backClick}>
            <img
              className="ImgNavBarArrow"
              src={require("../Images/Back.png")}
              alt=""
            />
          </Link>
          <Link
            to="/"
            onClick={backClick}
            className="navbar-text  text-dark text-decoration-none"
            id="titleNavBak"
          >
            {title}
          </Link>
          {!children && <span className="navbar-text  "></span>}
          {children}
        </div>
      </nav>
    </>
  );
}
